import React from "react";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 #008080;
  }
  100% {
    box-shadow: 0 0 0 14px #00808000;
  }
`;

const StyledLoader = styled.button`
  cursor: pointer;
  border: none;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1.5px;
  width: 170px;
  border-radius: 10px;
  background-color: #008080;
  color: #fff;
  font-weight: 600;
  animation: ${pulseAnimation} 1.5s infinite ease-in-out;
  font-size: 1rem;
`;

const ReservationButton = () => {
  return <StyledLoader>Időpontfoglalás</StyledLoader>;
};

export default ReservationButton;
